import { render, staticRenderFns } from "./ShippingLineView.vue?vue&type=template&id=18591f2a"
import script from "./ShippingLineView.vue?vue&type=script&lang=js"
export * from "./ShippingLineView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports